import { HttpForm } from "../Support/HttpForm";
import { axios } from "../Support/Axios";
import { Order } from "./Order";
export class CodeRedemption extends HttpForm {
    data = {
        code: null,
        key: null,
        pin: null,
        name: null,
        email: null,
        confirmEmail: null,
        accepted: false,
    };
    products = [];
    redemption = false;
    order = false;
    resetRedemption() {
        this.products = false;
        this.redemption = false;
        this.order = false;
        this.data = {
            code: null,
            key: null,
            pin: null,
            name: this.data.name,
            email: this.data.email,
            confirmEmail: this.data.confirmEmail,
            accepted: false,
        };
    }
    resetProductSelection() {
        this.order = false;
    }
    redeemCode() {
        const url = '/api/redeem/code';
        this.resetErrorStatus();
        return axios.post(url, this.data)
            .then((response) => {
            this.redemption = response.data;
            this.campaignProducts().then(r => { });
        })
            .catch(e => this.setError(e));
    }
    campaignProducts() {
        if (this.redemption) {
            const url = '/api/redeem/campaign/' + this.redemption.campaign.slug + '/product';
            return axios.get(url).then((response) => {
                this.products = response.data.data;
            }).catch(e => this.setError(e));
        }
        throw 'No Redemption Set';
    }
    selectProduct(sku) {
        if (this.redemption && this.products) {
            let product = this.products.find(product => product.sku === sku);
            if (product) {
                if (this.order === false) {
                    this.order = new Order(this.redemption.campaign, product, this.data);
                }
                return true;
            }
        }
        return false;
    }
    campaign() {
        if (this.redemption) {
            return this.redemption.campaign;
        }
        return false;
    }
    campaignIsActive() {
        let campaign = this.redemption ? this.redemption.campaign : false;
        return campaign && campaign.active && campaign.status.campaign_available_now;
    }
    getCampaignStatus() {
        let campaign = this.redemption ? this.redemption.campaign : false;
        if (campaign) {
            return campaign.status.campaign_status;
        }
        return 'Inactive';
    }
    productsLoaded() {
        return this.products !== false;
    }
    productSelected() {
        return this.order && this.order.productSelected();
    }
    valueInput() {
        return this.order && this.order.valueInput();
    }
    code() {
        if (this.redemption) {
            return this.redemption.code;
        }
        return false;
    }
}
